import axios from '@/utils/request';

/**
 * 协会概况（协会简介 / 发展历程 / 组织架构 / 领导风采 / 宗旨与目标 / 荣誉成就）
 * 客户端读取走 /about/{intro,history,org,leaders,objectives,honors}（公开），
 * 管理端读写走 /about/admin/**（需 JWT）。
 */
export default {
    // ---------- 客户端读取 ----------
    getIntro() {
        return axios.get('/about/intro');
    },
    getHistory() {
        return axios.get('/about/history');
    },
    getOrg() {
        return axios.get('/about/org');
    },
    getLeaders() {
        return axios.get('/about/leaders');
    },
    getObjectives() {
        return axios.get('/about/objectives');
    },
    getHonors() {
        return axios.get('/about/honors');
    },

    // ---------- 管理端：协会简介（单例） ----------
    adminIntro() {
        return axios.get('/about/admin/intro');
    },
    saveIntro(data) {
        return axios.post('/about/admin/intro/save', data);
    },

    // ---------- 管理端：发展历程 ----------
    adminHistory() {
        return axios.get('/about/admin/history');
    },
    addHistory(data) {
        return axios.post('/about/admin/history/add', data);
    },
    updateHistory(data) {
        return axios.post('/about/admin/history/update', data);
    },
    deleteHistory(id) {
        return axios.delete(`/about/admin/history/delete/${id}`);
    },

    // ---------- 管理端：组织架构 ----------
    adminOrg() {
        return axios.get('/about/admin/org');
    },
    addOrgNode(data) {
        return axios.post('/about/admin/org/add', data);
    },
    updateOrgNode(data) {
        return axios.post('/about/admin/org/update', data);
    },
    deleteOrgNode(id) {
        return axios.delete(`/about/admin/org/delete/${id}`);
    },

    // ---------- 管理端：领导风采 ----------
    adminLeaders() {
        return axios.get('/about/admin/leaders');
    },
    addLeader(data) {
        return axios.post('/about/admin/leader/add', data);
    },
    updateLeader(data) {
        return axios.post('/about/admin/leader/update', data);
    },
    deleteLeader(id) {
        return axios.delete(`/about/admin/leader/delete/${id}`);
    },

    // ---------- 管理端：宗旨与目标 ----------
    adminObjectives() {
        return axios.get('/about/admin/objectives');
    },
    addObjective(data) {
        return axios.post('/about/admin/objective/add', data);
    },
    updateObjective(data) {
        return axios.post('/about/admin/objective/update', data);
    },
    deleteObjective(id) {
        return axios.delete(`/about/admin/objective/delete/${id}`);
    },

    // ---------- 管理端：荣誉成就 ----------
    adminHonors() {
        return axios.get('/about/admin/honors');
    },
    addHonor(data) {
        return axios.post('/about/admin/honor/add', data);
    },
    updateHonor(data) {
        return axios.post('/about/admin/honor/update', data);
    },
    deleteHonor(id) {
        return axios.delete(`/about/admin/honor/delete/${id}`);
    },

    // ---------- 通用上传 ----------
    uploadFile(formData) {
        return axios.post('/minio/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }
};
